import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { InsightBadgeComponent } from '../insight-badge.component';
import { InsightBadge } from '../InsightBadge';
import { AppService } from '../../../../services/app-service';

@Component({
  selector: 'app-insight-review-badge',
  templateUrl: '../insight-badge/insight-badge.component.html',
  styleUrls: ['../insight-badge/insight-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppReviewBadgeComponent
  implements InsightBadgeComponent, OnChanges, OnInit
{
  @Input() data: any;
  @Output() anchorClick: EventEmitter<string> = new EventEmitter<string>();
  badge!: InsightBadge;
  constructor(
    private appService: AppService,
    private _changeDector: ChangeDetectorRef
  ) {}

  onAnchorClick(anchor: string) {
    this.anchorClick.emit(anchor);
  }
  ngOnInit() {
    this.updateBadge();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.updateBadge();
    }
  }

  updateBadge() {
    if (this.data) {
      const badge = {
        text: 'TEACHER',
        tooltip:
          'This app has been manually reviewed for the likely target audience.',
        icon: 'assets/images/icon-manually-reviewed.png',
        detected: true,
        detectedText: 'Reviewed',
        badgeColor: 'blue',
        anchorLink: '#app-coppa-permission-risk',
        hidden: !this.data.coppaPermissions?.isReviewedManually
      };

      this.badge = badge;
      this.appService.getWebsiteRatings().then(response => {
        const foundReview = response.find(rating =>
          Array.isArray(rating.appId)
            ? rating.appId.includes(this.data?.appOverview?.appId) ||
              rating.appId.includes(this.data?.overview?.appId)
            : rating.appId === this.data?.appOverview?.appId ||
              rating.appId === this.data?.overview?.appId
        );

        if (foundReview?.pageUrl) {
          this.badge.text = 'TEACHER REVIEWED';
          this.badge.detectedText = `<a href="${foundReview.pageUrl}" target="_blank">View Review</a>`;
          this.badge.anchorLink = null;
          this._changeDector.markForCheck();
          this._changeDector.detectChanges();
        }
      });
    }
  }
}
